import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { uhdrsFunctionalCapacity } from 'neuro-schemas';
import { formatPartialDate } from 'Utility/date';
import InfoPopover from 'Components/InfoPopover';

const { calculateScore } = uhdrsFunctionalCapacity;

const UHDRSFunctionalCapacity = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => (
  <HistorySection
    headerText={<FormattedMessage id="functionalPerformance.uhdrsFunctionalCapacity" />}
    newButton={
      <DocumentCreationButton
        name="uhdrsFunctionalCapacity"
        text="functionalPerformance.newUhdrsFunctionalCapacity"
        onClick={startEdit({}, 'uhdrsFunctionalCapacity')}
        width={20}
        height={3}
        fontSize={14}
        alternate={true}
      />
    }
  >
    <HistoryRowListing
      documents={documents}
      headers={
        <>
          <Item xs={2}>
            <FormattedMessage id="general.date" />
          </Item>
          <Item xs={2}>
            <FormattedMessage id="functionalPerformance.labels.uhdrsFunctionalCapacity.score" />
          </Item>
          <Item xs={8}>&nbsp;</Item>
        </>
      }
      contentFormat={d => (
        <>
          <Item xs={2}>{formatPartialDate(d.date ?? undefined)}</Item>
          <Item xs={2}>{calculateScore(d) ?? <InfoPopover text="general.notFilled" color="primary" />}</Item>
          <Item xs={5}>&nbsp;</Item>
          <Item xs={3}>
            <HistoryRowControls document={d} startEdit={startEdit} view={view} />
          </Item>
        </>
      )}
    />
  </HistorySection>
);

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<'uhdrsFunctionalCapacity'>>;
  startEdit: StartEdit;
  view?: IView;
}

export default UHDRSFunctionalCapacity;
